import { connect } from 'react-redux';
import WardsList from './WardsList';
import { updateRelation } from 'modules/Profile/redux/relations/actions';

const mapDispatchToProps = {
  updateRelation,
};

export default connect(null, mapDispatchToProps)(WardsList);
